import { SetStateAction, Dispatch, useState, FC } from 'react'
import generalClasses from '../tabs/styles.module.scss'
import { IInfrastructureProjectObject } from '../../../types/project.types'
import ReactSelect from 'react-select';
import { findOptionByValue, t } from '../../../helpers/utils';
import Field from '../../../components/field/field.component';
import { PlusIcon, XIcon } from '../../../assets/icons';
import classes from './styles.module.scss';

const translationKey = 'projects.infrastructure-projects';
const baseClass = 'sport-sections';

interface IProps {
  data: IInfrastructureProjectObject;
  setData: Dispatch<SetStateAction<IInfrastructureProjectObject>>;
  lang: 'ru' | 'kz';
  newSection: { label: string; value: string } | null;
  setNewSection: Dispatch<SetStateAction<{ label: string; value: string }>>;
  isAddingSection: boolean;
  setIsAddingSection: Dispatch<SetStateAction<boolean>>;
  parentErrors: Record<string, boolean>;
}

const SportSections: FC<IProps> = (
  {
    data,
    setData,
    lang,
    newSection,
    setNewSection,
    isAddingSection,
    setIsAddingSection,
    parentErrors
  }
) => {
  const [errors, setErrors] = useState<Record<string, boolean>>({});
  const suffix = lang === 'ru' ? 'Ru' : 'Kz';

  const sportSectionsList = [
    "no",
    "basketball",
    "boxing",
    "volleyball",
    "freestyle-wrestling",
    "greco-roman-wrestling",
    "judo",
    "kazakh-wrestling",
    "karate",
    "athletics",
    "skiing",
    "ping-pong",
    "swimming",
    "taekwondo",
    "dancing",
    "9kumalak",
    "weight-lifting",
    "figure-skating",
    "football",
    "hockey",
    "gymnastics",
    "chess"
  ].map(section => (
    { label: t(`${translationKey}.sport-sections.${section}`, lang), value: section }
  ));

  const handleInputChange = (field: string, value: string) => {
    setData(prev => {
      const prevSections = prev.infrastructureEntity?.sportSections || {};

      return {
        ...prev,
        infrastructureEntity: {
          ...prev.infrastructureEntity,
          sportSections: {
            ...prevSections,
            [field]: value
          }
        }
      };
    });
  };

  const startAddSection = () => {
    setNewSection({ label: '', value: '' });
    setIsAddingSection(true);
  };

  const cancelAddSection = () => {
    setIsAddingSection(false);
    setNewSection({ label: '', value: '' });
  };

  const saveNewSection = () => {
    const errors: Record<string, boolean> = {};
    if (!newSection) return;

    ['label', 'value'].forEach(field => {
      if (!newSection[field as keyof typeof newSection] && newSection.label !== sportSectionsList[0].value) {
        errors[field] = true;
      }
    });

    setErrors(errors);
    if (Object.keys(errors).length > 0) return;

    setData(prev => ({
      ...prev,
      infrastructureEntity: {
        ...prev.infrastructureEntity,
        sportSections: {
          ...prev.infrastructureEntity?.sportSections,
          [newSection.label]: newSection.value
        }
      }
    }));
    cancelAddSection();
  };

  const handleDeleteSection = (key: string) => {
    setData(prev => {
      const updatedSections = { ...prev.infrastructureEntity?.sportSections };
      delete updatedSections[key];

      return {
        ...prev,
        infrastructureEntity: {
          ...prev.infrastructureEntity,
          sportSections: updatedSections
        }
      };
    });
  }

  if (!data) return null;
  return (
    <div className={`${generalClasses[`field-block`]} ${generalClasses[`field-block--gray`]}`}>
      <div className={`${generalClasses['field-block__title']} `}>{t(`${translationKey}.sport-sections.title`, lang)}</div>

      {
        Object.entries(data.infrastructureEntity?.sportSections || {}).map(([key, value]) => (
          <div className={classes[`${baseClass}__item`]} key={key}>
            {
              key === 'no'
                ? <span>
                  {t(`${translationKey}.sport-sections.${key}`, lang)}
                </span>
                : <Field
                  key={key}
                  label={t(`${translationKey}.sport-sections.${key}`, lang)}
                  value={value}
                  onChange={(val) => handleInputChange(key, val.toString())}
                  type="text"
                  required
                  error={parentErrors[`sportSections.${key}`]}
                />
            }

            <button className={classes[`${baseClass}__btn`]} onClick={() => handleDeleteSection(key)}><XIcon /> </button>
          </div>
        ))
      }

      {!isAddingSection && (
        <div className={generalClasses['field-block__actions']}>
          <button onClick={startAddSection}>
            <PlusIcon /> {t(`actions.add`, lang)}
          </button>
        </div>
      )}

      {isAddingSection && newSection && (
        <div className={generalClasses['field-block']}>
          <ReactSelect
            options={sportSectionsList}
            value={findOptionByValue(newSection.label, sportSectionsList)}
            onChange={(option) => setNewSection(prev => ({ ...prev, label: option?.value || '' }))}
            placeholder=""
          />
          {
            newSection.label !== sportSectionsList[0].value && <Field
              label={t(`${translationKey}.value`, lang)}
              value={newSection.value}
              onChange={(val) => setNewSection(prev => ({ ...prev, value: val.toString() }))}
              error={errors.value}
              required
              type="number"
            />
          }
          <div className={generalClasses['field-block__actions']}>
            <button onClick={saveNewSection}>{t(`actions.save`, lang)}</button>
            <button onClick={cancelAddSection}>{t(`actions.cancel`, lang)}</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default SportSections